/* eslint-disable react/jsx-pascal-case */
import Usp from './usp-tag'
import ProductTable from './elements'

import sw from '@uswitch/ev-utils/switch'
import { getValue } from './utils'
import EligibilityInformation from './eligibility-information'
import DropDown from './dropdown'

export const AddonComponent = sw({
  'addons.Usp': ({ addon, data }) => {
    const usps = getValue(addon.usp, data)

    return []
      .concat(usps)
      .slice(0, addon.max || Infinity)
      .map((usp, index) => (
        <ProductTable.cells.Base key={index} sx={{ display: 'block' }} mobileOrder={-200}>
          <Usp key={usp} usp={usp} />
        </ProductTable.cells.Base>
      ))
  },

  'addons.Footer': ({ addon, data }) => {
    const footer = getValue(addon.footer, data)

    return (
      <ProductTable.cells.Base extraRules={{ display: 'block', fontSize: 'sm' }} mobileOrder={100}>
        <If condition={addon.label?.trim() && footer?.trim()}>
          <div sx={{ variant: 'compounds.product-table.variants.redesign.addonFooter.label' }}>
            {addon.label}
          </div>
          {footer}
        </If>
      </ProductTable.cells.Base>
    )
  },

  'addons.Info': ({ addon, data }) => {
    return (
      <ProductTable.cells.Base extraRules={{ display: 'block', fontSize: 'xs' }} mobileOrder={99}>
        <If condition={addon.info}>
          <div sx={{ variant: 'compounds.product-table.variants.redesign.addonInfo.label' }}>
            {addon.label}
          </div>
          <For each='item' of={addon.info} index='key'>
            <div>{getValue(item, data)}</div>
          </For>
        </If>
      </ProductTable.cells.Base>
    )
  },

  'addons.EligibilityCriteria': ({ addon, data, onClickEligibility }) => {
    const title = getValue(addon.title, data)
    const content = addon.content
    const variant = addon.headerImage ? 'eligibility-criteria-redesign' : 'eligibility-criteria'

    const onClick = () => {
      onClickEligibility && onClickEligibility(addon)
    }

    return (
      <ProductTable.cells.Base
        extraRules={{
          display: 'block',
          fontSize: 'xs',
          marginLeft: ['-8px', '-16px'],
          marginRight: ['-8px', '-16px'],
          marginBottom: '-40px',
          borderTop: 'none',
          paddingTop: 'none',
          marginTop: 'none',
        }}
        mobileOrder={100}
      >
        <DropDown title={title} variant={variant}>
          <EligibilityInformation
            content={content}
            data={data}
            headerImage={addon.headerImage}
            onClick={onClick}
          />
        </DropDown>
      </ProductTable.cells.Base>
    )
  },

  'addons.Image': ({ addon, data }) => {
    const image = getValue(addon.image, data)
    const alt = getValue(addon.alt, data)
    return (
      <ProductTable.cells.Image>
        <img src={image} alt={alt} sx={{ width: '100%', objectFit: 'cover' }} />
      </ProductTable.cells.Image>
    )
  },

  default: ({ addon, data }) => {
    console.error('Warning! Did not find addon')
    console.error(addon)
    return null
  },
})

export const AddonPosition = sw({
  'addons.position.Footer': ({ addon }) => ({
    addon: ProductTable.addons.footer,
    options: {
      split: addon.options?.split,
      headerImage: addon.options?.headerImage,
    },
  }),

  'addons.position.Info': ({ addon }) => ({
    addon: ProductTable.addons.info,
    options: {
      split: addon.options?.split,
      headerImage: addon.options?.headerImage,
    },
  }),

  'addons.position.EligibilityCriteria': {
    addon: ProductTable.addons.accordion,
  },

  'addons.position.Responsive': {
    addon: ProductTable.addons.responsive,
    options: { positions: ['body', 'header'] },
  },

  'addons.position.Image': {
    addon: ProductTable.addons.responsive,
    options: {
      headerOrder: -1,
      gridOrder: -1,
      positions: ['header', 'grid'],
    },
  },

  default: {
    addon: ProductTable.addons.responsive,
    options: { positions: ['body', 'header'] },
  },
})

export default (addons = [], data, onClickEligibility) =>
  addons.map(addon => ({
    component: AddonComponent(addon.type, { addon, data, onClickEligibility }),
    ...AddonPosition(addon.position, { addon, data }),
  }))
